import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Vuex from "vuex";
import vuetify from "./plugins/vuetify";
import globalMixins from '@/mixins/global'
import globalMap from '@/mixins/Map/layer'
import axios from "axios";
import Highcharts from "highcharts";
import Stock from "highcharts/modules/stock";
import exportingInit from "highcharts/modules/exporting";
import HighchartsVue from "highcharts-vue";


// init Global Mixins
Vue.mixin(globalMixins);
Vue.mixin(globalMap);

Vue.use(vuetify);

export const bus = new Vue

Vue.prototype.axios = axios;

// Vuex state
Vue.use(Vuex)

// Highchart
Stock(Highcharts);
exportingInit(Highcharts);
Vue.use(HighchartsVue);

//axios interceptors
let isRefreshing = false


Vue.config.productionTip = false;

new Vue({ 
  router,
  store,
  vuetify,
  render: (h) => h(App),
  created(){
    this.$store.dispatch('checkUserLocalStorage');

    var renewjwt_interval = null;

    this.$store.dispatch('refreshToken');
    renewjwt_interval = setInterval(()=>{ 
        this.$store.dispatch('refreshToken'); 
    }, 10 * 60 * 1000);

  }
}).$mount("#app");
